import { isAnyOf } from '@reduxjs/toolkit';
import { startAppListening } from '@app/listenerMiddleware';
import { enhancedApi as api } from '@services/df/auth';
import { uploadModelsActions, selectUploadJob } from '@modules/upload-models';

startAppListening({
    matcher: isAnyOf(api.endpoints.obtainAuthTokenCreate.matchFulfilled, api.endpoints.signupCreate.matchFulfilled),
    effect: async (action, { dispatch, getState, unsubscribe }) => {
        // just call it once on event
        unsubscribe();

        const state = getState();
        const uj = selectUploadJob(state);

        if (uj) {
            dispatch(uploadModelsActions.rebindUploadJob(uj));
        }
    },
});
